import { SVGProps } from 'react';


export default function Email(props: Partial<SVGProps<any>>) {
  return (
 <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M14.4 1.59961C14.8243 1.59961 15.2313 1.76818 15.5314 2.06824C15.8314 2.3683 16 2.77526 16 3.19961V12.7996C16 13.224 15.8314 13.6309 15.5314 13.931C15.2313 14.231 14.8243 14.3996 14.4 14.3996H1.6C1.17565 14.3996 0.768687 14.231 0.468629 13.931C0.168571 13.6309 0 13.224 0 12.7996V3.19961C0 2.31961 0.72 1.59961 1.6 1.59961H14.4ZM10.904 8.87961L16 12.7996V11.1996L11.904 8.07961L16 4.79961V3.19961L8 9.59961L0 3.19961V4.79961L4.096 8.07961L0 11.1996V12.7996L5.096 8.87961L8 11.1996L10.904 8.87961Z" fill="white"/>
</svg>
  )
}